/** First-touch fields for the session's landing page. Classification is server-side. */

const CLICK_ID_TYPES = [
  "gclid",
  "gbraid",
  "wbraid",
  "fbclid",
  "msclkid",
] as const;

export interface Acquisition {
  landingHost: string;
  landingPath: string;
  referrerHost: string;
  utmSource: string;
  utmMedium: string;
  utmCampaign: string;
  clickIdType: string;
  clickId: string;
  campaignKey: string;
}

/** `source|medium|campaign|clickType`. Empty when the URL has no UTMs and no click id. */
export function campaignKeyFromSearch(search: string): string {
  return acquisitionFromSearch(search, "", "", "").campaignKey;
}

export function acquisitionFromLocation(
  href: string,
  referrer: string,
): Acquisition {
  let url: URL;
  try {
    url = new URL(href);
  } catch {
    url = new URL("https://invalid.local/");
  }
  return acquisitionFromSearch(
    url.search,
    url.hostname,
    url.pathname,
    referrer,
  );
}

function acquisitionFromSearch(
  search: string,
  landingHost: string,
  landingPath: string,
  referrer: string,
): Acquisition {
  const params = new URLSearchParams(
    search.startsWith("?") ? search.slice(1) : search,
  );
  const utmSource = params.get("utm_source") ?? "";
  const utmMedium = params.get("utm_medium") ?? "";
  const utmCampaign = params.get("utm_campaign") ?? "";
  let clickIdType = "";
  let clickId = "";
  for (const type of CLICK_ID_TYPES) {
    const value = params.get(type);
    if (value) {
      clickIdType = type;
      clickId = value;
      break;
    }
  }
  const campaignKey =
    utmSource || utmMedium || utmCampaign || clickIdType
      ? `${utmSource}|${utmMedium}|${utmCampaign}|${clickIdType}`
      : "";
  return {
    landingHost,
    landingPath: landingPath || "/",
    referrerHost: hostnameOf(referrer),
    utmSource,
    utmMedium,
    utmCampaign,
    clickIdType,
    clickId,
    campaignKey,
  };
}

function hostnameOf(value: string): string {
  if (!value) return "";
  try {
    return new URL(value).hostname;
  } catch {
    return "";
  }
}
